<template>
  <div class="filter-bar-skeleton">
    <div class="filter-chips-row">
      <div class="filter-chip loading-effect" />
      <div class="filter-chip filter-chip--wide loading-effect" />
      <div class="filter-chip filter-chip--narrow loading-effect" />
      <div class="filter-chip loading-effect" />
    </div>
    <div class="filter-meta-row">
      <div class="result-count loading-effect" />
      <div class="order-by loading-effect" />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
@import '~/assets/css/loading.css';

.filter-bar-skeleton {
  @apply sticky top-[110px] md:top-[--kft-navbar-height] bg-white;
  @apply pb-1;

  &::before {
    content: '';
    @apply absolute top-0 bottom-0 left-[-9999px] right-[-9999px] z-[-1] bg-white;
  }
}

.filter-chips-row {
  @apply flex gap-2 pt-[11px] pb-3 overflow-x-auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.filter-chip {
  @apply rounded-full flex-shrink-0;
  height: 34px;
  width: 101px;

  @media (min-width: 768px) {
    height: 32px;
  }

  &--wide {
    width: 128px;
  }

  &--narrow {
    width: 80px;
  }
}

.filter-meta-row {
  @apply flex justify-between items-center pb-2;
}

.result-count {
  height: 14px;
  width: 90px;
  border-radius: 4px;
}

.order-by {
  height: 18px;
  width: 100px;
  border-radius: 9999px;
}
</style>
